import {createSlice} from "@reduxjs/toolkit";

const initialUser = localStorage.getItem('user');

const authSlice = createSlice({
    name: 'auth',
    initialState:{
        user: initialUser
    },
    reducers: {
        setCredentials(state, action){
            const newUser = action.payload;
            state.user = {
                token: newUser['access_token'],
                expiresIn: newUser['expires_in'],
                refreshToken: newUser['refresh_token'],
                logInTime: +new Date().getTime(),
                loggedIn: true
            }
            console.log(state.user)
            localStorage.setItem('user', JSON.stringify(state.user))
        },
        logOut(state, action){
            state.user = null
        }
    }
})

export const authActions = authSlice.actions
export default authSlice